<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Boundaries</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-area-chart
                  :height="250"
                  :data="ChartOptions.boundariesareachart.data"
                  :options="ChartOptions.boundariesareachart.options"
                ></chartjs-area-chart>
             </div>
        </div>
      </vs-col>
       <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Datasets</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-area-chart
                  :height="250"
                  :data="ChartOptions.datasetsareachart.data"
                  :options="ChartOptions.datasetsareachart.options"
                ></chartjs-area-chart>
             </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Stacked Area</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-area-chart
                  :height="250"
                  :data="ChartOptions.stackedareachart.data"
                  :options="ChartOptions.stackedareachart.options"
                ></chartjs-area-chart>
             </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Radar</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
             <chartjs-radar-chart
                  :height="250"
                  :data="ChartOptions.radarareachart.data"
                  :options="ChartOptions.radarareachart.options"
                ></chartjs-radar-chart>
             </div>
        </div>
      </vs-col>
      
       
    </div>
  </div>
</template>
<script>
import ChartjsAreaChart from "../../components/chartjs/ChartjsLineChart.vue";
import ChartjsRadarChart from "../../components/chartjs/ChartjsRadarChart.vue";
import ChartJS from "@/demo-data/Chart/Chartjs.js";

export default {
  components: {
   ChartjsAreaChart,
   ChartjsRadarChart
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
   ChartOptions: ChartJS[0],
    };
  },
};
</script>